// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getBrandSlug = (brandContent: any) => brandContent._meta?.slug;

export const sortPopularBrands =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (sortedHandlesMap: Map<string, number>) => (brandA: any, brandB: any) =>
    (sortedHandlesMap.get(getBrandSlug(brandA)) ?? Infinity) -
    (sortedHandlesMap.get(getBrandSlug(brandB)) ?? Infinity);
